module.exports = __webpack_public_path__ + "assets/img/warrior-name-71bbe9a1.png";